import React, {Component} from 'react';
import axios from 'axios';
import {Popover, PopoverBody, PopoverHeader, Form, FormGroup, Input, Label, Button} from 'reactstrap';
import {serverPath} from "../../common";

class RequestReview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.showPopover,
            courseProfessors: props.courseProfessors,
        };

        this.togglePopover = this.togglePopover.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            isOpen: newProps.showPopover,
            courseProfessors: newProps.courseProfessors,
        });
    }

    togglePopover() {
        if(this.state.isOpen) {
            //notify parent that modal is closed
            this.props.closePopoverHandler("0", "");
        }
        else {
            this.setState({isOpen: !this.state.isOpen});
        }
    }

    handleReviewRequest(event, submission) {
        var requestText = this.requestText.value;
        var chosenProf = this.chosenProfessor.value;
        //post request
        const params = new URLSearchParams();
        params.append('submissionId', submission.submissionId);
        params.append('requestText', requestText);
        params.append('chosenProfessor', chosenProf);
        params.append('action', 'requestReview');

        var self = this;
        axios.post(serverPath + "submissionService.php",params)
            .then(function (response) {
                alert("Vaš zahtev je uspešno prosleđen.");
                self.props.closePopoverHandler("1", requestText);
            });
    }

    render() {
        var submission = this.props.submission;
        let professorsJSX = this.state.courseProfessors.map((prof)=>{
            let toShow;
            if(prof.firstName !== null && prof.lastName !== null){
                toShow = prof.firstName + " " + prof.lastName;
            }
            else toShow = prof.avatar;
            return <option value={prof.idUser}>{toShow}</option>
        });
        if(submission === null) {
            return null;
        }
        else {
            return (
                <Popover placement="bottom" isOpen={this.state.isOpen}
                         target={"requestReview" + submission.submissionId} toggle={this.togglePopover}>
                    <PopoverHeader> Zatraži da nastavik pregleda kod </PopoverHeader>
                    <PopoverBody>
                        <Form>
                            <FormGroup>
                                <Label for="requestText"> Pitanje/Napomena </Label>
                                <Input type="textarea" name="text" id="requestText"
                                       innerRef={(input) => this.requestText = input}/>
                            </FormGroup>
                            <FormGroup>
                                <Label for="chosenProfessor"> Izaberite nastavnika</Label>
                                <Input type='select' name='chosenProfessor'
                                        innerRef={(input) =>{ this.chosenProfessor = input } }>
                                    {professorsJSX}
                                </Input>
                            </FormGroup>
                            <Button onClick={(event) => this.handleReviewRequest(event, submission)}> Pošalji zahtev </Button>
                        </Form>
                    </PopoverBody>
                </Popover>
            );
        }
    }
}

export default RequestReview;
